// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --color-blue : #5F2282;
    --color-2 : #E60073;
    --white:#ffffff;
    --black:#000000;
}


body {
    background: linear-gradient(0deg, var(--color-blue), var(--white)) !important;
}

.form-error {
    color: #a76161;
    text-align: center;
    margin-bottom: 10px;
}

.form-error1 {
    color: #a76161;
}

.login-box-body {
    box-shadow: 0 0px 30px var(--color-2);
}

.btn-primary{
    background: #2A2F4F !important;
    border: none;
    transform: scale(0.95);
    transition: all 0.5s;
}
.btn-primary:hover{
    transform: scale(1);
}

.card {
    padding: 2em;
  }
  
  .read-the-docs {
    color: #888;
  }
  .otpInput{
    width: 40px;
    height: 40px;
    margin: 5px;
    text-align: center;
    font-size: 1.2em;
  }
/* .page-item {
    background-color: red;
} */
`, "",{"version":3,"sources":["webpack://./src/Components/Css/Login.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI,6EAA6E;AACjF;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;EACd;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;GAEG","sourcesContent":[":root{\n    --color-blue : #5F2282;\n    --color-2 : #E60073;\n    --white:#ffffff;\n    --black:#000000;\n}\n\n\nbody {\n    background: linear-gradient(0deg, var(--color-blue), var(--white)) !important;\n}\n\n.form-error {\n    color: #a76161;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.form-error1 {\n    color: #a76161;\n}\n\n.login-box-body {\n    box-shadow: 0 0px 30px var(--color-2);\n}\n\n.btn-primary{\n    background: #2A2F4F !important;\n    border: none;\n    transform: scale(0.95);\n    transition: all 0.5s;\n}\n.btn-primary:hover{\n    transform: scale(1);\n}\n\n.card {\n    padding: 2em;\n  }\n  \n  .read-the-docs {\n    color: #888;\n  }\n  .otpInput{\n    width: 40px;\n    height: 40px;\n    margin: 5px;\n    text-align: center;\n    font-size: 1.2em;\n  }\n/* .page-item {\n    background-color: red;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
